/**
 * Busca una capa por su nombre dentro de un mapa OpenLayers y devuelve la capa encontrada.
 * @param {string} nameLayer - El nombre de la capa que se desea buscar.
 * @param {Object} map - El objeto de mapa OpenLayers en el que se realizará la búsqueda.
 * @returns {Object|null} La capa encontrada o null si no se encontró ninguna capa con el nombre especificado.
 */
export const findLayerByName = (nameLayer, map) => {
  if (map) {
    const layers = map.getLayers().getArray() // Obtén todas las capas del mapa
    const foundLayer = layers.find(layer => layer.get('name') === nameLayer) // Busca la capa por nombre

    return foundLayer // Devuelve la capa encontrada o undefined si no se encontró
  }
  return null // Si no hay mapa, la capa no puede existir
}
